import React, { Component } from 'react';
import { navigate } from 'gatsby';
import { styled } from '@mui/system';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Collapse from '@mui/material/Collapse';
import Hidden from '@mui/material/Hidden';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import SecurityIcon from '@mui/icons-material/Security';

const StyledListItemIcon = styled(ListItemIcon)((theme) => ({
    minWidth: '35px',
    color: '#fff',
}));

const StyledListItem = styled(ListItem)((theme) => ({
  textAlign: 'left',
  color: '#fff'
}));

class BottomAppBar extends Component {


  menuItemLink = (path, title, icon) => (
    <StyledListItem button
    onClick={() => { navigate('/' + path ); this.closeMenu(); } }
    >
    <StyledListItemIcon edge="end">
    {icon}
    </StyledListItemIcon>
    <ListItemText primary={title} fontSize="small" primaryTypographyProps={{ style: {fontSize: '0.9rem'} }}/>
    </StyledListItem>
  )

  openMenu = (event) => {
    const anchorEl = event.currentTarget;
    this.props.openMenuFn(!this.props.openMenu, anchorEl)
  };

  closeMenu = () => {
    this.props.openMenuFn(false, null);
  };

  render () {
    const {openMenu} = this.props;

      return (
              <AppBar position="fixed" type='footer' color="primary" sx={{top: 'auto', bottom: 0, position: 'absolute'}}>
                  <Toolbar>
                      {/*
                      <IconButton edge="start" color="inherit" aria-label="Open drawer">
                          <MenuIcon />
                      </IconButton>
                      */}
                      <div style={{flexGrow: 1}}><span style={{fontFamily: "'Lato', sans-serif", fontWeight: 700, fontSize: '0.9rem'}}>© {new Date().getUTCFullYear()} SMART&NIMBLE LTD</span></div>
                      {/*
                      <IconButton edge="end" color="inherit" onClick={this.openMenu}>
                          <MoreIcon />
                      </IconButton>
                      <List anchorEl={anchorEl} open={openMenu} onClose={this.closeMenu} >
                          {this.menuItemLink('terms', 'Terms of Service', <MenuBookIcon fontSize="small"/> )}
                          {this.menuItemLink('privacy', 'Privacy Policy', <SecurityIcon fontSize="small"/> )}
                      </List>
                      */}

                      <List
                        component="nav"
                        style={{textAlign: 'right'}}
                        subheader = {
                          <IconButton edge="end" color="inherit" onClick={this.openMenu}>
                              {openMenu ? <ExpandMore /> : <ExpandLess />}
                          </IconButton>
                        }
                      >
                        <Collapse in={this.props.openMenu} timeout="auto" unmountOnExit>
                          <Hidden only={['xs']}>
                            {this.menuItemLink('terms', 'Terms of Service', <MenuBookIcon fontSize="small"/> )}
                            {this.menuItemLink('privacy', 'Privacy Policy', <SecurityIcon fontSize="small"/> )}
                          </Hidden>
                          <Hidden only={['sm', 'md', 'lg', 'xl']}>
                            {this.menuItemLink('terms', 'Terms', <MenuBookIcon fontSize="small"/> )}
                            {this.menuItemLink('privacy', 'Privacy', <SecurityIcon fontSize="small"/> )}
                          </Hidden>
                        </Collapse>
                      </List>
                  </Toolbar>
              </AppBar>
      );
  }
}

export default BottomAppBar;
